import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';

import { getConsumptionTypeLabel } from 'utils/convertMetrics';
import commonStyles from 'views/SpecificationDocument/DocumentView/Common/commonStyles';

import { Detail } from '../../../DetailsPage/Details';

const styles = StyleSheet.create({
  cell: {
    ...commonStyles.fontM,
    color: '#000001',
    padding: '2px 0px',
  },
  mainCell: {
    width: '30%',
    marginRight: '2%',
  },
  consumptionsCell: {
    width: '68%',
    flexDirection: 'row',
  },
  consumptionCell: {
    textAlign: 'center',
  },
  consumptionVariedCell: {
    flex: 0.1,
  },
});

function ComponentConsumptions({
  consumptions,
  consumptionVariedOnSize,
  hasPiecesPerMarker,
  piecesPerMarker,
  productionTimeDays,
  productCategory,
  t,
  i18n,
}) {
  return (
    <View style={{ display: 'flex', flexDirection: 'column', width: '25%' }}>
      <View style={styles.titleWrapper}>
        <Text style={commonStyles.sectionTitle}>{`${t('consumption')} [${getConsumptionTypeLabel(
          productCategory?.consumptionType,
          i18n,
        )}]`}</Text>
      </View>
      {hasPiecesPerMarker && piecesPerMarker && (
        <View style={commonStyles.detailRow}>
          <Detail title="" description={t('pieces_per_marker')} width="65%" />
          <Detail title="" description={piecesPerMarker} width="35%" />
        </View>
      )}
      {productionTimeDays && (
        <View style={commonStyles.detailRow}>
          <Detail title="" description={t('production_time_days')} width="65%" />
          <Detail title="" description={`${productionTimeDays} ${t('days')}`} width="35%" />
        </View>
      )}
      {!consumptionVariedOnSize && consumptions?.length > 0 && (
        <View style={commonStyles.detailRow}>
          <Detail title="" description={t('same_size_variant')} width="65%" />
          <Detail title="" description={consumptions[0]?.consumption} width="35%" />
        </View>
      )}
      {consumptionVariedOnSize &&
        consumptions?.filter(Boolean).map((consumption) => (
          <View key={consumption.id} style={commonStyles.detailRow}>
            <Detail
              title=""
              description={consumption?.modelSpecificationSize?.sizeName?.name || '-'}
              width="65%"
            />
            <Detail title="" description={consumption?.consumption || '-'} width="35%" />
          </View>
        ))}
    </View>
  );
}

export default withTranslation('specification')(ComponentConsumptions);
